export var COMMENTS_ALLOWED_TYPE = {
    post: 'post',
    team: 'team',
    none: 'none'
};
export var CHAT_CLOSED_STATUS = {
    open: 0,
    pause: 1,
    close: 2
};
export var INITIAL_REQUEST_FILTER = {
    page: 1,
    limit: 10,
    offset: 0
};
export var INITIAL_PARENT_REQUEST_FILTER = {
    page: 1,
    limit: 5,
    offset: 0
};
export var POST_STATUS = {
    active: 0,
    deleted: 1
};
export var COMMENT_NOTIF_TYPE = {
    add: 3
};
export var COMMENT_EDIT_MODE = {
    add: 'add',
    edit: 'edit',
    answer: 'answer',
};
export var SCROLL_POSITION = {
    start: 'start',
    center: 'center',
    end: 'end'
};
export var COMMENT_INIT_OFFSET = 1;
export var COMMENT_OFFSET = 5;
export var SUB_COMMENT_OFFSET = 3;
//# sourceMappingURL=const.js.mapexport var COMMENTS_ALLOWED_TYPE = {
    post: 'post',
    team: 'team',
    none: 'none'
};
export var CHAT_CLOSED_STATUS = {
    open: 0,
    pause: 1,
    close: 2
};
export var INITIAL_REQUEST_FILTER = {
    page: 1,
    limit: 10,
    offset: 0
};
export var INITIAL_PARENT_REQUEST_FILTER = {
    page: 1,
    limit: 5,
    offset: 0
};
export var POST_STATUS = {
    active: 0,
    deleted: 1
};
export var COMMENT_NOTIF_TYPE = {
    add: 3
};
export var COMMENT_EDIT_MODE = {
    add: 'add',
    edit: 'edit',
    answer: 'answer',
};
export var SCROLL_POSITION = {
    start: 'start',
    center: 'center',
    end: 'end'
};
export var COMMENT_INIT_OFFSET = 1;
export var COMMENT_OFFSET = 5;
export var SUB_COMMENT_OFFSET = 3;
//# sourceMappingURL=const.js.map